export type Rating = 1 | 2 | 3 | 4 | 5;

export const is = (v: number): v is Rating => [1, 2, 3, 4, 5].includes(v);
